<!--    @reset="showTree?$refs.treeSelect.clearHandle():null" -->
<template>
  <div>
    <list row-key="CarId" ref="list" unit="考勤设备选择" :expand-all-row="true" :page="true" :query-params="params"
      :show-checkbox="showCheckbox && $permission.canWrite()" :show-query="showQuery" :get-data-func="api.list">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
             <el-form-item label="设备编号">
          <el-input type="text" v-model="params.No" placeholder="请输入事件名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input type="text" v-model="params.name" placeholder="请输入考勤对象" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SectionNumber" :width="isMB?60:80" label="设备编号" />
        <el-table-column prop="Grade" :width="240" label="设备名称" />
        <el-table-column prop="SectionName" label="设备IP"  :width="140" />
        <el-table-column prop="EndTime" :min-width="isMB?120:''" label="设备位置" />

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>

import listMixin from "@/mixins/list";
import list from "@/components/common/list";


export default {
  mixins: [listMixin],
  components: {
    list,
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true
    },
    showTree: {
      type: Boolean,
      default: true
    },
    showRecord: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      api: require("@/api/ed/section").default,
      params: {
        name: "",
        No: "",
      },
      isMB: this.$store.state.isMB,
    };
  },
  beforeMount() {

  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>